export default __webpack_public_path__ + "static/media/wishlists2.dccc98b8.svg";